document.addEventListener("DOMContentLoaded", () => {
  // Limpa localStorage ao carregar a página
  localStorage.removeItem("simulatedQuantity");

  const minusButton = document.querySelector("button.minus");
  const plusButton = document.querySelector("button.plus");
  const quantityInput = document.querySelector('input[name="quantity"]');
  const addToCartButton = document.getElementById("AddToCart");
  const itemCounts = document.querySelectorAll(".thb-item-count");

  // Inicializa quantidade
  let simulatedQuantity = parseInt(quantityInput?.value || 1);
  localStorage.setItem("simulatedQuantity", simulatedQuantity);

  // Atualiza input e localStorage
  const updateQuantity = (newQty) => {
    simulatedQuantity = Math.max(1, newQty); // Garante mínimo 1
    if (quantityInput) quantityInput.value = simulatedQuantity;
    localStorage.setItem("simulatedQuantity", simulatedQuantity);
  };

  if (minusButton) {
    minusButton.addEventListener("click", () => {
      updateQuantity(simulatedQuantity - 1);
    });
  }

  if (plusButton) {
    plusButton.addEventListener("click", () => {
      updateQuantity(simulatedQuantity + 1);
    });
  }

  if (addToCartButton && itemCounts.length > 0) {
    addToCartButton.addEventListener("click", () => {
      const storedQuantity = parseInt(localStorage.getItem("simulatedQuantity") || "1");
      itemCounts.forEach((itemCount) => {
        const current = parseInt(itemCount.textContent) || 0;
        itemCount.textContent = current + storedQuantity;
      });

      // (Opcional) limpa a quantidade simulada após adicionar
      localStorage.removeItem("simulatedQuantity");
      updateQuantity(1);
    });
  }
});